/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscPhoneinfoRequest = { phone: string };

export const GetMiscPhoneinfoRequest$zodSchema: z.ZodType<
  GetMiscPhoneinfoRequest
> = z.object({
  phone: z.string().describe("需要查询的11位中国大陆手机号码。"),
});

export type GetMiscPhoneinfoInternalServerErrorDetails = {};

export const GetMiscPhoneinfoInternalServerErrorDetails$zodSchema: z.ZodType<
  GetMiscPhoneinfoInternalServerErrorDetails
> = z.object({});

/**
 * 查询失败。我们的号码归属地数据库可能暂时无法访问，请稍后重试。
 */
export type GetMiscPhoneinfoInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetMiscPhoneinfoInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetMiscPhoneinfoInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetMiscPhoneinfoInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetMiscPhoneinfoInternalServerErrorDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("查询失败。我们的号码归属地数据库可能暂时无法访问，请稍后重试。");

export type GetMiscPhoneinfoBadRequestDetails = {};

export const GetMiscPhoneinfoBadRequestDetails$zodSchema: z.ZodType<
  GetMiscPhoneinfoBadRequestDetails
> = z.object({});

/**
 * 请求参数错误。请检查你是否提供了 `phone` 参数，以及它是否是有效的11位手机号码。
 */
export type GetMiscPhoneinfoBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetMiscPhoneinfoBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetMiscPhoneinfoBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscPhoneinfoBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscPhoneinfoBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求参数错误。请检查你是否提供了 `phone` 参数，以及它是否是有效的11位手机号码。",
);

/**
 * 查询成功！返回号码的归属地和运营商信息。
 */
export type GetMiscPhoneinfoResponseBody = {
  city?: string | undefined;
  province?: string | undefined;
  sp?: string | undefined;
};

export const GetMiscPhoneinfoResponseBody$zodSchema: z.ZodType<
  GetMiscPhoneinfoResponseBody
> = z.object({
  city: z.string().optional(),
  province: z.string().optional(),
  sp: z.string().optional(),
}).describe("查询成功！返回号码的归属地和运营商信息。");

export type GetMiscPhoneinfoResponse =
  | GetMiscPhoneinfoResponseBody
  | GetMiscPhoneinfoBadRequestResponseBody
  | GetMiscPhoneinfoInternalServerErrorResponseBody;

export const GetMiscPhoneinfoResponse$zodSchema: z.ZodType<
  GetMiscPhoneinfoResponse
> = z.union([
  z.lazy(() => GetMiscPhoneinfoResponseBody$zodSchema),
  z.lazy(() => GetMiscPhoneinfoBadRequestResponseBody$zodSchema),
  z.lazy(() => GetMiscPhoneinfoInternalServerErrorResponseBody$zodSchema),
]);
